(function() {
  var ContractsHandler, Router,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Router = App.loadClass('core::Router');

  ContractsHandler = App.loadClass('portal::handlers/contracts/Contracts_Handler');

  exports.ContractsRouter = (function(superClass) {
    extend(ContractsRouter, superClass);

    function ContractsRouter() {
      return ContractsRouter.__super__.constructor.apply(this, arguments);
    }

    ContractsRouter.prototype.prefix = 'Contracts';

    ContractsRouter.prototype.module_name = 'ContractsRouter';

    ContractsRouter.prototype.register = function() {
      return this.module = angular.module(this.module_name, ['ui.router', 'ui.bootstrap']);
    };

    ContractsRouter.prototype.registerRoutes = function($stateProvider) {
      return $stateProvider.state('portal.contracts', {
        url: '/contracts',
        template: '<div></div>',
        controller: [
          '$scope', function($scope) {
            var ref;
            App.current_page = new ContractsHandler();
            if ((ref = App.sidebar) != null) {
              if (typeof ref.open === "function") {
                ref.open();
              }
            }
            return App.current_page.init();
          }
        ]
      });
    };

    return ContractsRouter;

  })(Router);

}).call(this);
